/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mentormatchgender2Inputs */

const en__field_mentormatchgender2 = /** @type {(inputs: _Field_Mentormatchgender2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With whom do you want to get machted?`)
};

const de__field_mentormatchgender2 = /** @type {(inputs: _Field_Mentormatchgender2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit wem möchtest du gematcht werden?`)
};

/**
* | output |
* | --- |
* | "With whom do you want to get machted?" |
*
* @param {_Field_Mentormatchgender2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_mentormatchgender2 = /** @type {((inputs?: _Field_Mentormatchgender2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mentormatchgender2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentormatchgender2(inputs)
	return de__field_mentormatchgender2(inputs)
});
export { _field_mentormatchgender2 as "_field_mentorMatchGender" }